import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PaginationService} from "./pagination.service";
import {PaymentSourceType, StripeAccountType} from "../_models";

@Injectable()
export class PaymentSourceService extends PaginationService {
  constructor(protected http: HttpClient) {
    super(http, 'account/payment_sources');
  }

  createFromToken(type: PaymentSourceType, token: string, accountType: StripeAccountType) {
    return this.http.post(this.route + '/', {
      resourcetype: type,
      token: token,
      stripe_account_type: accountType,
    });
  }

  getFinancialConnectionsSession(accountType: StripeAccountType) {
    return this.http.post<{client_secret: string}>(
      this.route + `/financial_connections_session/${accountType}/`, {});
  }

  createBankAccount(accountId: string, accountType: StripeAccountType) {
    return this.createFromToken(PaymentSourceType.BankAccount, accountId, accountType);
  }
}
